import { render, staticRenderFns } from "./SchoolIndexView.vue?vue&type=template&id=5fad03b4&scoped=true&"
import script from "./SchoolIndexView.vue?vue&type=script&lang=js&"
export * from "./SchoolIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad03b4",
  null
  
)

export default component.exports